import LoadingLink from './LoadingLink';

export default LoadingLink;
